import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import HostListLayer from "../../components/HostBusiness/HostBusinessListLayer";


const HostListLayerPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Host Business" />

        {/* UsersListLayer */}
        <HostListLayer />

      </MasterLayout>

    </>
  );
};

export default HostListLayerPage; 
